import { z } from "zod"

export const powurOsEquipmentTypeSchema = z.object({
  id: z.number().int(),
  name: z.string(),
})
export type PowurOsEquipmentType = z.infer<typeof powurOsEquipmentTypeSchema>
